import { useCallback, useId } from "react";
import { SwitchPill } from "@sablier/v2-components/atoms";
import { Action } from "@sablier/v2-components/molecules";
import { IPermissionInfo } from "~/client/types";

interface Props {
  info: IPermissionInfo;
  update: (id: string) => void;
  value: boolean;
}

function Item({ info, value, update }: Props) {
  const id = useId();

  const toggle = useCallback(() => {
    update(info.id);
  }, [info, update]);

  return (
    <Action title={info.name} maxWidth={300} description={info.description}>
      <SwitchPill id={id} isChecked={value} onChange={toggle} />
    </Action>
  );
}

export default Item;
